import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'boolean' } )
export class BooleanPipe implements PipeTransform {

    transform( pIsBoolean: boolean ): string {
        if ( pIsBoolean != null ) {
            return pIsBoolean === true ? 'Yes' : 'No';
        }
        return 'None';
    }
}
